<template>
  <section>
    <nav :class="{ 'nav-open': isNavOpen }">
      <div class="brand">
        <img :src="brandLogo" alt="PreEvnt" class="brand-logo" />
        <div class="brand-text">
          <span class="brand-name">PreEvnt</span>
          <span class="brand-sub">Admin Panel</span>
        </div>
      </div>
      <ul class="nav-links">
        <router-link tag="a" to="/dashboard">
          <i class="fa fa-chart-pie nav-icon" /><span>Dashboard</span>
        </router-link>
        <router-link tag="a" to="/users">
          <i class="fa fa-users nav-icon" /><span>App Users</span>
        </router-link>
        <router-link tag="a" to="/devices">
          <i class="fa fa-microchip nav-icon" /><span>Devices</span>
        </router-link>
        <router-link tag="a" to="/measurements">
          <i class="fa fa-chart-line nav-icon" /><span>Measurements</span>
        </router-link>
        <router-link tag="a" to="/glucose-readings">
          <i class="fa fa-tint nav-icon" /><span>Glucose Readings</span>
        </router-link>
        <router-link v-if="isAdmin" tag="a" to="/accounts">
          <i class="fa fa-user-shield nav-icon" /><span>Accounts</span>
        </router-link>
      </ul>
      <VersionBadge />
      <div class="nav-footer">
        <router-link tag="a" to="/profile" class="profile-link">
          <i class="fa fa-user-circle nav-icon" /><span>Profile</span>
        </router-link>
      </div>
    </nav>

    <b-button class="nav-toggle" @click="toggleNav">
      <i :class="isNavOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
    </b-button>
    <main>
      <header class="topbar">
        <h1 class="topbar-title">{{ pageTitle }}</h1>
        <div class="topbar-spacer" />
        <div class="user-pill">
          <img :src="userProfileImage" alt="" class="user-avatar" />
          <div class="user-meta">
            <span class="user-name">{{ userName }}</span>
            <span class="user-role">{{ userRole == 1 ? "Admin" : "Monitor" }}</span>
          </div>
        </div>
        <button class="signout" @click="handleSignOut">
          <i class="fa fa-sign-out-alt" />
          <span>Sign out</span>
        </button>
      </header>
      <div class="routeContainer">
        <router-view></router-view>
      </div>
    </main>
  </section>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/utils/apiBase";
import { clearAuth, getAuthItem, getAuthToken } from "@/utils/authStorage";
import { avatarUrl } from "@/utils/avatar";
import BRAND_LOGO from "@/assets/adm-panel-logo.png";
import VersionBadge from "@/components/VersionBadge.vue";
export default {
  components: { VersionBadge },
  data() {
    return {
      isNavOpen: false,
      errors: "",
      brandLogo: BRAND_LOGO,
      userName: getAuthItem("fullName"),
      userRole: parseInt(getAuthItem("userRole"), 10),
      userProfileImage: avatarUrl(getAuthItem("profileImageURL")),
    };
  },
  computed: {
    pageTitle() {
      const titles = {
        "/dashboard": "Dashboard",
        "/users": "App Users",
        "/devices": "Devices",
        "/measurements": "Measurements",
        "/glucose-readings": "Glucose Readings",
        "/accounts": "Accounts",
        "/profile": "Profile",
      };
      return titles[this.$route.path] || "";
    },
    isAdmin() {
      return parseInt(getAuthItem("userRole"), 10) === 1;
    },
  },
  methods: {
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    },
    handleSignOut() {
      const token = getAuthToken();

      axios
        .post(
          `${API_BASE_URL}/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          clearAuth();
          this.$router.push("/login");
          alert(response.data.message); // Show success message
        })
        .catch((error) => {
          console.error("Logout failed", error);
          this.errors = error;
          alert("Logout failed");
        });
    },
  },
};
</script>
<style scoped>
section {
  width: 100vw;
  height: 100vh;
  display: flex;
  background: #f4f6fa;
  color: #1f2540;
}

main {
  flex: 1 1 0%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

/* ---------------- sidebar ---------------- */
nav {
  width: 16rem;
  height: 100%;
  padding: 1.1rem 0.75rem;
  background: #ffffff;
  border-right: 1px solid #e6e8ee;
  box-shadow: 1px 0 0 rgba(16, 24, 40, 0.02);
  display: flex;
  flex-direction: column;
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.35rem 0.6rem 1.1rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #eef0f4;
}
.brand-logo {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  object-fit: contain;
  flex-shrink: 0;
}
.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}
.brand-name {
  font-weight: 800;
  font-size: 1rem;
  color: #1f2540;
}
.brand-sub {
  font-size: 0.72rem;
  color: #98a0ad;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

ul.nav-links {
  list-style: none;
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  flex: 1;
  min-height: 0;
}

.nav-links a,
.profile-link {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.55rem 0.75rem;
  border-radius: 8px;
  text-decoration: none;
  color: #5b6577;
  font-size: 0.92rem;
  font-weight: 500;
  height: auto;
  width: 100%;
  transition: background 0.15s, color 0.15s;
}
.nav-links a:hover,
.profile-link:hover {
  background: #f4f6fa;
  color: #2a345d;
}
.nav-links a.router-link-active,
.profile-link.router-link-active {
  background: #2a345d;
  color: #ffffff;
}
.nav-links a.router-link-active .nav-icon,
.profile-link.router-link-active .nav-icon {
  color: #ffffff;
}
.nav-icon {
  width: 1.1rem;
  text-align: center;
  font-size: 0.95rem;
  color: #98a0ad;
}

.nav-footer {
  padding-top: 0.75rem;
  border-top: 1px solid #eef0f4;
  margin-top: 0.5rem;
}

.nav-toggle {
  display: none;
  position: fixed;
  top: 5px;
  left: 10px;
  background: none;
  color: black;
  border: none;
  padding: 10px;
  font-size: 1.5rem;
  z-index: 1500;
}

@media (max-width: 600px) {
  nav {
    width: 75%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }
  .nav-toggle {
    display: block;
  }
  nav.nav-open {
    transform: translateX(0);
  }
}
nav.nav-open {
  transform: translateX(0);
}

/* ---------------- topbar ---------------- */
.topbar {
  width: 100%;
  height: 4rem;
  background: #ffffff;
  border-bottom: 1px solid #e6e8ee;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0 1.25rem;
  box-sizing: border-box;
}
.topbar-title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2540;
  letter-spacing: -0.01em;
}
.topbar-spacer {
  flex: 1;
}

.user-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.2rem 0.75rem 0.2rem 0.2rem;
  border: 1px solid #e6e8ee;
  border-radius: 999px;
  background: #f7f8fb;
}
.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}
.user-meta {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}
.user-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1f2540;
}
.user-role {
  font-size: 0.7rem;
  color: #5b6577;
  font-weight: 500;
}

.signout {
  height: 36px;
  padding: 0 0.9rem;
  border: 1px solid #e6e8ee;
  background: #ffffff;
  border-radius: 8px;
  color: #5b6577;
  font-size: 0.88rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.signout:hover {
  background: #2a345d;
  border-color: #2a345d;
  color: #ffffff;
}

/* ---------------- routes ---------------- */
.routeContainer {
  width: 100%;
  flex: 1 1 0%;
  padding: 1.25rem 1.5rem;
  overflow-y: auto;
  min-height: 0;
}
/* Some views already pad their wrapper — drop their right padding here so
   the routeContainer's padding is the single source of truth. */
.routeContainer ::v-deep .measurements-wrap {
  padding-right: 0;
}
</style>
